export default "__VITE_ASSET__DhQQ7dqF__";